<script lang="ts">
	import { Accordion } from 'svelte-components';
	export let faqItems = [];

	let expandedIndex = 0;

	function handleCardToggle(index: number, event) {
		const { action } = event.detail;
		if (action === 'expand') {
			expandedIndex = index;
		} else {
			expandedIndex = -1;
		}
	}
</script>

<section
	aria-label="Frequently Asked Questions"
	class="bg-background-alt px-padding_lg py-8 lg:px-0 lg:py-12"
>
	<div class="mx-auto max-w-8xl lg:px-3">
		<div class="flex flex-col items-center gap-padding_xsm text-center">
			<h2
				class="text-[1.1875rem] font-semibold leading-[1.5rem] text-backdrop lg:font-barlow lg:text-[2rem]"
			>
				Frequently Asked Questions
			</h2>
			<p
				class="mx-auto max-w-[53.75rem] body_small tracking-[0.0015rem] text-body lg:mt-padding_xsm lg:body_large"
			>
				Have questions? Find all the answers you need about becoming an Angel One Authorised Person
				in our FAQ section.
			</p>
		</div>

		<div
			class="mx-auto mt-padding_xxlg w-full max-w-[77.75rem] overflow-hidden rounded-shape-corner_md border border-[#dddfe4] bg-background-alt"
		>
			{#each faqItems as item, index}
				<Accordion
					data={item}
					initialExpand={expandedIndex === index}
					titleFontSize="text-[0.8125rem] lg:text-[0.9375rem]"
					titleStyle="!ml-0 !text-backdrop tracking-[0.01625rem] leading-[1.25rem] {expandedIndex ===
					index
						? '!font-medium'
						: '!font-normal'}"
					headerClass="!p-padding_lg lg:!px-padding_xlg {expandedIndex === index
						? 'bg-[#e8ecfc]'
						: ''} {index === 0 && expandedIndex === 0 ? 'rounded-t-shape-corner_md' : ''} {index > 0
						? 'border-t border-border'
						: ''}"
					hoverTextColor="hover:text-primary"
					textColor="text-primary"
					class="!mt-0 !rounded-none !shadow-none !max-w-none"
					on:cardToggled={(e) => handleCardToggle(index, e)}
				>
					<svelte:fragment slot="accordionBody">
						<div
							class="p-padding_lg body_small tracking-[0.0015rem] text-body lg:px-padding_xlg lg:body_large"
						>
							{item.body}
						</div>
					</svelte:fragment>
				</Accordion>
			{/each}
		</div>
	</div>
</section>
